/**
 * FingerprintJS service for guest user tracking
 * Provides browser fingerprinting for rate limiting
 */
import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

/**
 * Initialize FingerprintJS
 * @returns {Promise} FingerprintJS instance promise
 */
const initFingerprint = () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
};

/**
 * Get or generate fingerprint ID
 * Stores in localStorage for reuse
 * @returns {Promise<string>} Fingerprint visitor ID
 */
export const getFingerprint = async () => {
  try {
    // Check if we already have a fingerprint in localStorage
    const stored = localStorage.getItem('fingerprint_id');
    if (stored) {
      return stored;
    }

    // Generate new fingerprint
    const fp = await initFingerprint();
    const result = await fp.get();
    const visitorId = result.visitorId;

    // Store for future use
    localStorage.setItem('fingerprint_id', visitorId);
    
    return visitorId;
  } catch (error) {
    console.error('Error getting fingerprint:', error);
    // Fallback to a random ID if fingerprinting fails
    const fallbackId = `fallback_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('fingerprint_id', fallbackId);
    return fallbackId;
  }
};

/**
 * Clear stored fingerprint
 * Useful for testing or debugging
 */
export const clearFingerprint = () => {
  localStorage.removeItem('fingerprint_id');
};

export default {
  getFingerprint,
  clearFingerprint
};
